module.exports = __webpack_public_path__ + "img/favicon-nw.46bae7e6.png";